var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFilter32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6.25H10C8.48122 6.25 7.25 7.48122 7.25 9V12.6397L7.25714 12.8377C7.30455 13.4947 7.58662 14.1154 8.05546 14.5842L12.071 18.599L12.0714 24.9361C12.0714 25.3489 12.2128 25.7492 12.472 26.071C13.1003 26.8511 14.2437 26.9774 15.0284 26.3543L19.2597 22.7881L19.3796 22.6835C19.7239 22.3533 19.9286 21.8809 19.9286 21.3838L19.928 18.482L22.1069 16.3487C22.6476 15.8224 23.2496 15.2382 23.9129 14.596C24.4479 14.078 24.75 13.3651 24.75 12.6203V9C24.75 7.48122 23.5188 6.25 22 6.25ZM10 7.75H22C22.6904 7.75 23.25 8.30964 23.25 9V12.6203C23.25 12.9589 23.1127 13.2829 22.8695 13.5184L20.0564 16.2536L18.4286 17.8581V21.3838C18.4286 21.478 18.3852 21.5675 18.3099 21.6273L14.0787 25.1935C13.9561 25.2904 13.7511 25.2677 13.6402 25.1301C13.5956 25.0747 13.5714 25.0063 13.5714 24.9361V17.9789L9.11612 13.5236C8.8817 13.2891 8.75 12.9712 8.75 12.6397V9C8.75 8.30964 9.30964 7.75 10 7.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter32);
export default __webpack_public_path__ + "static/media/icon-filter-32.8b4ee9f6.svg";
export { ForwardRef as ReactComponent };